let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4VV25")).then(() => parcelRequire('hhX4N'));